module.exports = __webpack_public_path__ + "img/authenticator_twilio.cbc70c69.png";